import { css } from 'emotion';

export namespace styles {
  export const container = css({ width: '100%' });

  export const valueContainer = (base: any, inGroup?: boolean) => ({
    ...base,
    height: 45,
    padding: `5px ${inGroup ? 0 : '13px'}`
  });

  export const placeholder = css({});

  export const logoContainer = css({
    width: '100%',
    display: 'flex',
    marginTop: 8,
    justifyContent: 'flex-end',
    '> img': {
      width: '112px',
      height: '14px'
    }
  });

  export const control = (baseRules: any, inGroup: boolean = false) => {
    return {
      ...baseRules,
      backgroundColor: 'white',
      border: 'none',
      boxShadow: inGroup ? 'none' : undefined,
      '&:focused': inGroup
        ? {
            border: 'none',
            boxShadow: 'none'
          }
        : undefined,
      '&:hover': inGroup
        ? {
            border: 'none',
            boxShadow: 'none'
          }
        : undefined
    };
  };
}
